import { statsData } from "@/mocks/comparisonData";

export default function StatsBar() {
  return (
    <section className="bg-secondary-100/60 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-4xl md:text-5xl font-extrabold text-foreground-950 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}